<template>
  <v-select
    v-model="thisValue"
    :items="industryTypeItems"
    hint="Industry"
    item-text="description"
    item-value="key"
    label="Select Industry Type"
    persistent-hint
    single-line
  ></v-select>
</template>

<script>
export default {
  name: 'OrderDetailIndustry',
  data () {
    return {
      industryTypeItems: [
        {key: 'retail', description: 'Retail'},
        {key: 'restaurant', description: 'Restaurant'}
      ]
    }
  },
  computed: {
    thisValue: {
      get () {
        return this.$store.getters.getOrder['industry']
      },
      set (val) {
        this.$store.commit('updateOrder', ['industry', val])
      }
    }
  }
}
</script>

<style scoped>

</style>
